var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { Observable } from "rxjs";
import "rxjs-compat";
import { ofType, combineEpics } from "redux-observable";
import { switchMap, map } from "rxjs/operators";
import experimentResource from "@ane/exp-data/lib/resources/ExperimentResources";
import experimentSearchResource from "@ane/exp-data/lib/resources/ExperimentSearchResource";
import experimentSearchConstants from "./ExperimentSearch/ExperimentSearchConstants.js";
import ExperimentSearchActions from "./ExperimentSearch/ExperimentSearchActions.js";
import MyActivitiesActions from "./MyActivities/MyActivitiesActions.js";
import myActivitiesActionTypes from "./MyActivities/MyActivitiesActionTypes.js";
const fetchScorecardsEpic = (action$) => {
  return action$.pipe(
    ofType(experimentSearchConstants.FETCH_SCORE_CARDS, myActivitiesActionTypes.FETCH_SCORE_CARDS),
    switchMap((value) => {
      const expIds = value.payload;
      return Observable.fromPromise(experimentResource.scorecardData(expIds)).pipe(
        map((result) => {
          const data = result.getSuccessData().map((data2, id) => __spreadProps(__spreadValues({}, data2), {
            Id: expIds[id]
          }));
          if (value.queryType) {
            return MyActivitiesActions.getAllScoreCardsAction(value.queryType, data);
          }
          return ExperimentSearchActions.getAllScoreCardsAction(data);
        })
      );
    })
  );
};
const fetchStatusEpic = (action$) => {
  return action$.pipe(
    ofType(experimentSearchConstants.LOAD_STATUS_DATA, myActivitiesActionTypes.FETCH_STATUS),
    switchMap((value) => {
      const featureRolloutIds = value.payload;
      if (!featureRolloutIds.length)
        return Observable.empty();
      return Observable.forkJoin(featureRolloutIds.map((id) => experimentSearchResource.getStatusData(id))).pipe(
        map((data) => {
          let finalData = {};
          data.forEach((d, id) => {
            finalData[featureRolloutIds[id]] = d;
          });
          if (value.queryType) {
            return MyActivitiesActions.updateMyActivitiesStatusData(value.queryType, finalData);
          }
          return ExperimentSearchActions.updateStatusData(finalData);
        })
      );
    })
  );
};
const searchEpics = combineEpics(fetchScorecardsEpic, fetchStatusEpic);
export {
  fetchScorecardsEpic,
  fetchStatusEpic,
  searchEpics
};
//# sourceMappingURL=SearchEpics.js.map
